import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
class CompletedScreen extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        if(!this.props.visible) return null;

        const getMinutes = ()=>{
            let mins =  Math.floor(this.props.time/60);
            if(mins==0) return null;
            return mins+" mins ";
        }

        const getSeconds = ()=>{
            if(this.props.time==0){
                return "00" + " secs";
            }
            let seconds = this.props.time % 60;
            if(seconds<10){
                return '0'+Math.round(seconds) + " secs";
            }
    
            return Math.round(seconds) + " secs";

            
        }

        return (
            <div className="CompletedScreen">
                <div className="wrap">
                    <p style={{fontSize : 21}}>Well Done!</p>
                    {(this.props.time)? <p style={{fontSize : 31, color:"#882B2B", fontWeight:700}} >{getMinutes()}{getSeconds()}</p> : null }
                
                    <p>Let us know your time in the comments below.</p>
                    <Button color="#822C30" style={{marginLeft: 'auto', marginRight:'auto'}} onClick={this.props.onReset}>PLAY AGAIN</Button>
                </div>
                
                <style jsx>{`

                    @keyframes enter {
                        from {
                        opacity: 0;
                        transform: scale3d(0.3, 0.3, 0.3);
                        }
                        50% {
                        opacity: 1;
                        }
                        to {
                        opacity:1;
                        transform: scale3d(1, 1, 1);
                        }
                    }
                    .CompletedScreen {
                        background: rgba(255,255,255, 0.95);
                        position: absolute;
                        top:0px;
                        left:0px;
                        right:0px;
                        bottom:0px;
                        padding:30px!important;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        animation-name: enter; 
                        animation-duration: 0.3s;
                    }

                    
                    @media all and (max-width:768px){
                        .CompletedScreen {
                            position: fixed;
                        }
                    }
                    .wrap {
                        text-align: center;
                    }
                    p {
                        margin-bottom:20px!important;
                        font-size:18px;

                        color: #494848;
                    }
                    
                `}</style>
            </div>
        )
    }
}

CompletedScreen.propTypes = {
    
}

export default CompletedScreen;